var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"}},[_c('path',{attrs:{"d":"M1.34.67h9.32a.83.83 0 01.58 1.42L6.6 6.74a.83.83 0 01-1.18 0L.76 2.1A.83.83 0 011.34.67z","fill":"#242424"}})])}
var staticRenderFns = []

export { render, staticRenderFns }